/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
export var DateComponent = {
    propertyName: 'dateComponent',
    isCellRenderer: function () { return false; }
};
export var HeaderComponent = {
    propertyName: 'headerComponent',
    isCellRenderer: function () { return false; },
};
export var HeaderGroupComponent = {
    propertyName: 'headerGroupComponent',
    isCellRenderer: function () { return false; },
};
export var CellRendererComponent = {
    propertyName: 'cellRenderer',
    isCellRenderer: function () { return true; },
};
export var PinnedRowCellRendererComponent = {
    propertyName: 'pinnedRowCellRenderer',
    isCellRenderer: function () { return true; },
};
export var CellEditorComponent = {
    propertyName: 'cellEditor',
    isCellRenderer: function () { return false; },
};
export var InnerRendererComponent = {
    propertyName: 'innerRenderer',
    isCellRenderer: function () { return true; },
};
export var LoadingOverlayComponent = {
    propertyName: 'loadingOverlayComponent',
    isCellRenderer: function () { return false; },
};
export var NoRowsOverlayComponent = {
    propertyName: 'noRowsOverlayComponent',
    isCellRenderer: function () { return false; },
};
export var TooltipComponent = {
    propertyName: 'tooltipComponent',
    isCellRenderer: function () { return false; },
};
export var FilterComponent = {
    propertyName: 'filter',
    isCellRenderer: function () { return false; },
};
export var FloatingFilterComponent = {
    propertyName: 'floatingFilterComponent',
    isCellRenderer: function () { return false; },
};
export var ToolPanelComponent = {
    propertyName: 'toolPanel',
    isCellRenderer: function () { return false; },
};
export var StatusPanelComponent = {
    propertyName: 'statusPanel',
    isCellRenderer: function () { return false; },
};
